$(document).ready(function () {
	const hash = window.location.hash;

	$('a[href*="#"]')
		.not('.popup-btn')
		.click(function (e) {
			const target = this.hash;
			const targetTab = target.substring(1);
			const $target = $('#' + targetTab);

			if ($target.length) {
				e.preventDefault();
				$('html, body')
					.stop()
					.animate(
						{
							scrollTop: $target.offset().top - 90
						},
						800
					);
			} else {
				const $linkToAnotherPage = $('a[href*="' + target + '"]').not('.popup-btn');

				if ($linkToAnotherPage.length) {
					e.preventDefault();
					window.location.href = $linkToAnotherPage.attr('href');
				}
			}
		});

	if (hash) {
		const $location = $(hash);

		if ($location.length) {
			setTimeout(function () {
				$('html, body').animate(
					{
						scrollTop: $location.offset().top - 90
					},
					800
				);
			}, 200);
		} else {
			const $linkToAnotherPage = $('a[href*="' + hash + '"]').not('.popup-btn');

			if ($linkToAnotherPage.length) {
				window.location.href = $linkToAnotherPage.attr('href');
			}
		}
	}
});
